import { useCallback, useState } from 'react'

export function useForceUpdate() {
  const [, setTrigger] = useState<boolean>(false)

  return useCallback(() => {
    setTrigger(trigger => !trigger)
  }, [])
}
